var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DcwGridWrapper',{staticClass:"dcw-join-us"},[_vm._l((Object.values(_vm.content.cards)),function(card,index){return [_c('DcwJoinUsCard',{key:index,attrs:{"data":card,"is-left":index === 0,"is-right":index === 1}})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }